module.exports = __webpack_public_path__ + "static/media/signal_head_green.dc572d5a.glb";